<template>
  <div>
    <v-dialog persistent v-model="showDialog" max-width="700" class="mx-auto">
      <v-card :loading="exportInProgress">
        <v-card-title>
          {{ $t('export_progress_title') }}
        </v-card-title>
        <v-card-text>
          <v-checkbox readonly :label="$t('export_status.tmp_files_created')" v-model="this.tmpFilesCreated">
          </v-checkbox>
          <v-checkbox readonly :label="$t('export_status.files_copied')" v-model="this.filesCopied">
          </v-checkbox>
          <v-progress-linear height="15">
            <template v-slot:default="{ }">
              {{ exportedFileCount }} / {{ totalFileCount }}
            </template>
          </v-progress-linear>
          <v-checkbox readonly :label="$t('export_status.archive_created')" v-model="this.archiveCreated">
          </v-checkbox>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-5 py-5">
          <v-btn @click="navigateToBoxes()">
            {{ $t('export_status.back_to_boxes') }}
          </v-btn>
          <v-btn @click="downloadExport()" color="primary" :disabled="!exportSuccess">
            {{ $t('export_status.download_export') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar color="success" v-model="showSuccessSnackbar">
      {{ $t('export_status.export_success') }}
    </v-snackbar>
    <v-snackbar color="error" v-model="showErrorSnackbar">
      {{ $t('export_status.export_error') }}
    </v-snackbar>
  </div>
</template>

<script>
import ExportService from '@/services/export/ExportService'

export default {
  name: 'ExportProgress',
  props: ['showDialog', 'exportIdentifier'],
  data: () => ({
    exportInProgress: true,
    exportSuccess: false,
    tmpFilesCreated: false,
    filesCopied: false,
    archiveCreated: false,
    exportedFileCount: 0,
    totalFileCount: 0,
    exportId: -1,
    showErrorSnackbar: false,
    showSuccessSnackbar: false
  }),
  unmounted () {
    this.exportInProgress = false
  },
  watch: {
    showDialog () {
      if (this.showDialog === true) {
        this.exportInProgress = true
        this.tmpFilesCreated = false
        this.filesCopied = false
        this.archiveCreated = false
        this.exportedFileCount = 0
        this.totalFileCount = 0
        this.exportId = -1
        this.exportSuccess = false
        this.checkStatusLoop()
      }
    }
  },
  methods: {
    navigateToBoxes () {
      this.$router.push('BoxList')
    },
    downloadExport () {
      if (this.exportId <= 0) {
        return
      }
      this.$router.push({ name: 'ExportHistory', params: { downloadExportId: this.exportId } })
    },
    async checkStatusLoop () {
      while (this.exportInProgress === true) {
        await this.sleep(250)
        await ExportService.getExportStatus(this.exportIdentifier).then(exportProgress => {
          this.exportInProgress = exportProgress.exportStatus === 1
          this.tmpFilesCreated = exportProgress.tmpFilesCreated
          this.filesCopied = exportProgress.filesCopied
          this.archiveCreated = exportProgress.archiveCreated
          this.exportedFileCount = exportProgress.exportedFileCount
          this.totalFileCount = exportProgress.totalFileCount
          if (this.exportInProgress === false) {
            if (exportProgress.exportStatus === 0) {
              this.exportId = exportProgress.exportId
              this.showSuccessSnackbar = true
              this.exportSuccess = true
            } else {
              this.showErrorSnackbar = true
            }
          }
        }, _ => {
          this.exportInProgress = false
          this.showErrorSnackbar = true
        })
      }
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/exports/ExportProgress.vue